import {
  IButtonMenu
} from '@wangeditor/editor'

// 自定义「源码」菜单：点击后派发全局事件，由页面切换源码/编辑模式
class WangEditorHtml {
  constructor () {
    this.title = '源码'
    this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145z m610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z"></path><path d="M281 249l1.7 24.3 22.7 253.5h206.5v-0.1h112.9l-11.4 118.5L511 672.9v0.2h-0.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-0.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v0.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z"></path></svg>'
    this.tag = 'button'
  }

  // 获取菜单执行时的 value，用不到则返回空字符串或 false
  getValue (editor) {
    return ''
  }

  // 菜单是否激活：通过全局状态判断是否处于源码模式
  isActive (editor) {
    return window.__wangeditor_source_mode__ || false
  }

  // 菜单是否禁用：源码按钮永远不禁用
  isDisabled (editor) {
    return false
  }

  // 点击菜单时触发：派发全局事件通知页面切换源码模式
  exec (editor, value) {
    if (this.isDisabled(editor)) return
    const event = new CustomEvent('wangeditor-toggle-source', { detail: { editor } })
    window.dispatchEvent(event)
  }
}

export default WangEditorHtml
